import { render } from "./WFHReport.vue?vue&type=template&id=09e70fd6"
import script from "./WFHReport.vue?vue&type=script&lang=js"
export * from "./WFHReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__